import * as React from "react";
import {DynamicDialog, DynamicDialogState} from "shared/controls/Dialogs/core/DynamicDialog";
import {DialogProps} from "shared/controls/Dialogs/core/Dialog";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";

export class TemplatePicker extends DynamicDialog<TemplatePickerProps,TemplatePickerState> {
    static defaultProps: Partial<TemplatePickerProps> = {};

    constructor(props: TemplatePickerProps) {
        super(props);
        this.state = {
            IsOpen:true,
            SelectedItem:this.props.Templates.length>0?this.props.Templates[0].Id:null
        };
    }


    GetAdditionalProperties(): DialogProps {
        return {
            Title:'Select a template',
            EnableCancel:this.props.Templates.length>1,
            EnableApply:true,
            ApplyTitle:'Done',
            OnApply:()=>{
                this.SendResult(this.state.SelectedItem)
            }
        }
    }

    SubRenderer(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return (
            this.props.Templates.length==0?
                <h3>This form doesn't have any PDF template, <a href={''}>Click here to create one</a> </h3>:
                <SearchableSelect Value={this.state.SelectedItem} onChange={e=>this.setState({SelectedItem:e})}>
                    {this.props.Templates.map(x=>
                        <option key={x.Id} value={x.Id}>{x.Name}</option>
                    )}
                </SearchableSelect>

        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface TemplatePickerProps {
    Templates:{Id:string,Name:string}[]
}

interface TemplatePickerState extends DynamicDialogState{
    SelectedItem:any
}